import React from "react"
import SEO from "../../components/seo"
import HeroFeaturePage from "../../components/pages/shared/hero/feature-page"
import Layout from "../../components/layout"
import AboutComponent from "../../components/pages/main/about"
import FeaturesComponent from "../../components/pages/main/landing-features"
import ContactFormComponent from "../../components/pages/shared/contact-form"
import FeaturesGridComponent from "../../components/pages/features/grid"
import styles from "./feature.module.scss"
import GalleryComponent from "../../components/pages/features/gallery"
import FeaturePriceCards from "../../components/pages/features/feature-price"
import NotificationsAccordionComponent from "../../components/pages/features/notifications/accordion"
import Blocks from "../../components/pages/features/block-for"
import Head from "../../components/pages/features/head"
import Discount from "../../components/pages/main/discount"
import Breadcrumb from '../../components/controls/breadcrumbs';

const notificationsAccordionData = [
  {
    name: "advantages",
    title: "Какие преимущества СМС-рассылок через CRM для детских центров?",
    content: `<p>А вы знали, что 90% полученных СМС открывается в течение первых трех минут? Это самый высокий показатель касания с клиентом среди маркетинговых инструментов. И к тому же, не самый дорогой.</p>
    <p>Рассмотрим основные плюсы СМС-рассылки через CRM:</p>
    <ol>
      <li>Номер телефона один.</li>
      <li>Мессенджеры или email-адреса есть не у всех, а номер наоборот.</li>
      <li>Мобильный всегда под рукой.</li>
      <li>Не нужен доступ в Интернет.</li>
      <li>Высокий процент открываемости.</li>
      <li>Отправка от выбранного имени.</li>
      <li>Относительно низкая стоимость рассылки.</li>
    </ol>
    <p>Используя СМС-рассылки через CRM, вы сможете охватить свою целевую аудиторию максимально точным предложением. Интеграция провайдера СМС-рассылок и CRM-системы для детских центров позволит сделать этот процесс удобным, быстрым и легким для сотрудников образовательного бизнеса. Для того, чтобы сделать рассылку в CRM нужно только выбрать конкретного ученика или группу учеников с помощью встроенных фильтров системы. Далее написать текст сообщения и отправить его. Все действия в режиме одного окна.</p>
    `
  },
  {
    name: "autonotifications",
    title: "Как работают автоматические уведомления из CRM-системы?",
    content: `В Параплан CRM вы можете настроить автописьма по Email или SMS для односторонней коммуникации с клиентами, лидами или сотрудниками. Для этого во вкладке “Уведомления” раздела “Настройки” самостоятельно выберите те автоуведомления, которые должны приходить вашим коллегам и ученикам. Например, вы можете выбрать, что все ученики будут получать уведомление по SMS об отмене или переносе занятия, участником которого они являются. Также педагогу будет приходить Email-оповещение об отмене записи, переносе занятия и так далее. В Параплан CRM предложены различные триггеры (события/действия), используя которые вы сможете сократить количество ручного труда. Система будет отправлять информацию за вас без лишних действий. Кроме этого, есть возможность настроить, сотрудникам с какими именно ролями отправлять те или иные автоуведомления. Плюс вы можете решить, за сколько дней до события нужно рассылать уведомления. Таким образом, обеспечивается своевременное информирование клиентов о скором окончании действия абонемента, планируемом посещении пробного занятия или отмене/переносе урока.`
  }
]

const ClientsFeaturePage = (props) => {
  const crumbs = [
    { name: 'Главная', url: '/'},
    { name: 'Возможности', url: '/feature'},
    { name: 'Автоуведомления', url: ''}
  ];
  return (
    <Layout className={styles.clients} headerColor={"#319DED"} page={"notifications"}>
      <SEO
        title="Автоуведомления и рассылки через CRM-систему Параплан"
        description="Используйте Email и SMS рассылки через CRM систему Параплан. Настройте автоматическую отправку уведомлений клиентам, лида и напоминаний сотрудникам."
        url={"https://paraplancrm.ru" + props.location.pathname}
      />
      <HeroFeaturePage
        name={"notifications"}
        title='Повышайте лояльность клиентов благодаря рассылкам'
        description='Автоматизируйте рутину с помощью триггерных уведомлений и сконцентрируйтесь на продажах.'
        color='#319DED'
        btnDark={true}
        image={require("../../images/cover/notifications.png")} />
      <Breadcrumb crumbs={ crumbs } arrowcolor={"blue"}/>
      <Head
        center={true}
        title="Автоматические уведомления по WhatsApp, SMS и Email"
        subtitle="Влияйте на продажу путем одностороннего общения и напоминайте команде о задачах по клиентам и лидам."
      />
      <AboutComponent
        title='Уведомления <br/> клиентов и лидов'
        description='Теперь сотрудникам не обязательно звонить клиенту или лиду для напоминания о себе. Краткие и полезные сообщения содержат только ту информацию, которая полезна клиенту. Напоминайте о посещении, информируйте об изменениях, сообщайте об оплате в автоматическом режиме. Уведомления придут по часовому поясу пользователя.'
        image={require("../../images/screenshot/notification/lead-notifications.png")}
        imageWidth={676}
        imageHeight={364}
        bgSize={"position-bottom"}
        reverse={true}
        color='#03C4A4' />
      <AboutComponent
        title='Уведомления <br/> сотрудников'
        description='Автоматические сообщения из CRM-системы повышают качество вашего сервиса и улучшают коммуникацию. Ответственный сотрудник не тратит время на поиск информации, а сразу работает с клиентом или лидом. Освободите рабочее время администраторов, при этом сократите количество опозданий и переносов в расписании.'
        image={require("../../images/screenshot/notification/employee-notifications.png")}
        imageWidth={676}
        imageHeight={364}
        bgSize={"position-top"}
        color='#FFC800' />
      <Discount />
      <Blocks
        title="Самостоятельно выбирайте, какие уведомления будут отправляться клиентам и сотрудникам"
      />
      <FeaturesGridComponent
        threeItems={true}
        page={"notifications"}
        features={[
          {
            name: "Экономия времени и сил",
            text: "Снижение временных и трудовых затрат менеджеров.",
            image: require("../../images/icons/statement.svg"),
          },
          {
            name: "Помощь клиентам",
            text: "Своевременное информирование клиентов о том, что им нужно. ",
            image: require("../../images/icons/notification.svg"),
          },
          {
            name: "Напоминание о компании",
            text: "Понимание клиентов, что о них помнят и заботятся.",
            image: require("../../images/icons/instant-alerts.svg"),
          },
        ]} />
      <AboutComponent
        title='Настройка <br/> оповещений'
        description='Работайте с уведомлениями из системы так, как нужно вам. Выберите один режим рассылки сотрудникам из трех, добавьте исключения. Нужная информация по клиентам придет только ответственным менеджерам.'
        image={require("../../images/screenshot/notification/setting-notification.png")}
        imageWidth={676}
        imageHeight={573}
        bgSize={"position-bottom"}
        reverse={true}
        color='#03C4A4' />
      <AboutComponent
        title='История <br/> автоуведомлений'
        description='Просматривайте отправленные WhatsApp, SMS и Email уведомления в профиле лида или клиента. В любой момент руководитель может посмотреть, как сотрудники работали с CRM.'
        image={require("../../images/screenshot/notification/history-notification.png")}
        imageWidth={676}
        imageHeight={364}
        bgSize={"position-top"}
        circlePosition={-44}
        color='#FFC800' />

      <GalleryComponent
        title={"Интеграция с сервисами WhatsApp и СМС рассылок"}
        subtitle={"Персонализируйте общение с клиентами, быстро информируйте их о событиях компании."}
        galleryView={"img"}
        headerCenter={true}
        offShadow={true}
        smallMargin={true}
        data={[
          {
            name: "mailings",
            title: "Массовые рассылки",
            content: "Достигайте максимальной скорости информирования клиентов: в несколько кликов делайте рассылки по всей базе, непродленным абонементам, конкретной группе или статусу.",
            image: require("../../images/screenshot/integration/mailings2.png"),
          },
          {
            name: "individual",
            title: "Индивидуальные рассылки",
            content: "Повышайте лояльность клиентов через внимание и заботу о них. Поздравьте клиентов с Днем рождения, другими праздниками, благодарите после покупки или визита.",
            image: require("../../images/screenshot/integration/individual2.png"),
          },
          {
            name: "various",
            title: "Разные сервисы",
            content: `
            Выберите один из доступных в Параплан CRM сервисов. Операторы рассылок для РФ: 
            <a href=' https://smsvizitka.com/' target='_blank'>СМС-Визитка</a>,
            <a href='http://sms.ru/' target='_blank'>SMSRU</a>,   
            <a href='https://smsaero.ru/' target='_blank'>SMS AERO</a>,   
            <a href='https://www.sms4b.ru/' target='_blank'>SMS4B</a>. 
            Также доступен 1 оператор для Украины: 
            <a href='https://turbosms.ua/' target='_blank'>TURBOSMS</a>. 
            
          `,
            image: require("../../images/screenshot/integration/various2.png"),
          },
        ]}
      />

      <FeaturePriceCards
        pageName="notifications"
        title="Повышайте рейтинг доверия к компании!"
        text="Стоимость интеграции с автоуведомлениями и рассылками"
      />

      <FeaturesComponent title="Дополнительные возможности" />
      <ContactFormComponent />
      <NotificationsAccordionComponent
        data={notificationsAccordionData}
        title='Удержание клиентов с помощью рассылок через CRM для детского центра'
        descr='Повышение лояльности клиентской базы - процесс трудоемкий. Мы становимся более придирчивы к сервису и предоставляемым нам услугам, ожидаем индивидуального подхода и дополнительного внимания. Сегодняшнему клиенту недостаточно сухих отношений купли/продажи, ему хочется, чтобы о нем помнили, заботились и предвосхищали желания. Организовать рабочий процесс таким образом, чтобы не упускать даже мельчайшие детали, довольно сложно в ручном режиме. Здесь необходима автоматизация коммуникации с клиентом, чтобы сосредоточить внимание сотрудников на продажах и качественном сервисе. В CRM-системе есть инструменты, которые помогут вам не только попасть в ожидания клиентов, но и превзойти их. Например, автоматические уведомления и SMS-рассылки через CRM. Автоуведомления - это автоматические рассылки сообщений вашим клиентам, лидам и сотрудникам. Они отправляются по триггеру - настроенному событию в CRM-системе. СМС-рассылки - один из главных инструментов персональной коммуникации с учениками и родителями. Данные функциональности позволяют быть на связи с клиентами, напоминать им о себе, демонстрировать высокий уровень клиентского сервиса. Клиенты обязательно оценят вашу заботу и внимание, и это будет дополнительным аргументом всегда выбирать только ваш центр.'
      />
    </Layout>
  )
}

export default ClientsFeaturePage
